/*
 * QuestionnairesList Messages
 *
 * This contains all the text for the QuestionnairesList container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.QuestionnairesList';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Questionnaries',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'total',
  },
  addQuestionnaire: {
    id: `${scope}.addQuestionnaire`,
    defaultMessage: 'Add questionnaire',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
});
